import React,{useEffect, useState} from 'react';
import { useSelector } from "react-redux";

import styles from '@/views/pages/SimpleText/SimpleText.module.scss';

const SimpleTextStats = ({ 
	simpleStats: { inputStatistics, outputStatistics, simplificationSummary },
	clearText,
	//addText,
	//convertedText,
	//userRole,
}) => {
	const [ headerShown, setHeaderShown ] = useState(false);
	const [ panelShown, setPanelShown ] = useState(false);
	const [ detailsShown, setDetailsShown ] = useState(false);

	const dict = useSelector(state => state.app.dict);
	const { hideDetails, showDetails, difficultyRatingBadge, simplifiedRatingBadge, simplifyNewText } = dict.simpletext.stats;
	
	useEffect(() => {
		if (inputStatistics && outputStatistics) {
			setTimeout(() => setHeaderShown(true), 100);
			setTimeout(() => setPanelShown(true), 1000);
		}
	}, [ inputStatistics, outputStatistics ]);

	return (
		<section className={ styles['st-stats'] }>
			<div className={ `${styles['st-stats__header']}${headerShown ? ` ${styles['shown']}` : ''}` }>
				<div className={ styles['st-stats__header__left'] }>
					<div className={ inputStatistics.rate !== outputStatistics.rate ? styles['st-stats__header__left__improved-level'] : styles['st-stats__header__left__same-level'] }>{simplificationSummary}</div>
				</div>
				<div className={ styles['st-stats__header__right'] }>
					<button
						className='button__white'
						onClick={ clearText }
					>
						{ simplifyNewText }
					</button>
				</div>
			</div>
			<div className={ `${styles['st-stats__graphs__wrapper']}${panelShown ? ` ${styles['shown']}` : ''}` }>
				<StatGraph 
					level={ inputStatistics.rate }
					textRate={ inputStatistics.textRate }
					pisarek={ inputStatistics.pisarek }
					fog={ inputStatistics.fog }
					tooltipText={ difficultyRatingBadge }
					shown={ panelShown }
				/>
				<StatGraph 
					level={ outputStatistics.rate }
					textRate={ outputStatistics.textRate }
					pisarek={ outputStatistics.pisarek }
					fog={ outputStatistics.fog }
					tooltipText={ simplifiedRatingBadge }
					shown={ panelShown }
				/>
			</div>
			<div className={ styles['st-stats__button'] }>
				<button 
					className={ `button__transparent ${styles['st-stats__button--show-details']}` }
					onClick={ () => setDetailsShown(shown => !shown) }
				>
					{ detailsShown ? <>
						{hideDetails}
						<i className="icon-arrow-up-full" />
					</> : <>
						{showDetails}
						<i className="icon-arrow-down-full" />
					</>  }
				</button>
			</div>
			<div className={ `${styles['st-stats__indexes-help__wrapper']}${(panelShown && detailsShown) ? ` ${styles['shown']}` : ''}` }>
				<IndexesHelp />
			</div>
		</section>
	);
};

export default SimpleTextStats;

const StatGraph = ({
	level=1, 
	steps=6,
	pisarek='',
	fog='',
	textRate='',
	tooltipText='',
	shown='false',
}) => {
	const dict = useSelector(state => state.app.dict);
	const { easyText, hardText, pisarekIndex, fogIndex } = dict.simpletext.stats;
	return (
		<div className={ styles['st-stats__graph__container'] }>
			<p className={ styles['st-stats__name'] }>{tooltipText}</p>
			<div className={ styles['st-stats__graph__points--container'] }>
				<div className={ styles['st-stats__graph__points'] }>
					<span>{level}</span> / 6
				</div>
				<div className={ styles['st-stats__graph__points--text'] }>
					- {textRate}
				</div>
			</div>
			<div className={ `${styles['st-stats__graph']}${shown ? ` ${styles['shown']}` : ''}` }>
				<div className={ styles['st-stats__graph__left-icon'] }>{easyText}</div> 
				<div className={ styles['st-stats__graph__main'] }>
					<div className={ styles['st-stats__graph__tooltip__wrapper'] }>
						<div 
							className={ styles['st-stats__graph__tooltip__content'] }
							style={ {left: `calc((100% / ${steps - 1}) * ${level - 1})`} }
						>
							<h2>
								{level}
							</h2>
						</div>
					</div>
					<div className={ styles['st-stats__graph__scale-bar--gradient'] } />
					<div className={ styles['st-stats__graph__scale-bar--line'] } />
					<div className={ styles['st-stats__graph__scale-bar'] } >
						<div className={ styles['st-stats__graph__scale-bar--wrapper'] }>
							{ Array.from(Array(steps), (_, i) => i+1).map((el => (
								<span key={ `span${el}` }>{el}</span>
							))) }
						</div>
					</div>
				</div>
				<div className={ styles['st-stats__graph__right-icon'] }>{hardText}</div>
			</div>
			<div className={ styles['st-stats__graph__indexes'] }>
				<span>{ pisarekIndex }<sup>1</sup>: <span className={ styles['st-stats__graph__indexes--number'] }>{pisarek}</span></span>
				<span>{ fogIndex }<sup>2</sup>: <span className={ styles['st-stats__graph__indexes--number'] }>{fog}</span></span>
			</div>
		</div>
	);
};

const IndexesHelp = () => {
	const dict = useSelector(state => state.app.dict);
	const { description, pisarek, fog } = dict.simpletext.indexesHelp;
	return (
		<div className={ styles['st-stats__indexes-help__single'] }>
			<div className={ styles['st-stats__indexes-help__elements'] }>
				<div className={ styles['st-stats__indexes-help__elements__description'] }>
					{ description.part1 }<strong>{ description.part2 }</strong>{ description.part3 }
				</div>
				<div className={ styles['st-stats__indexes-help__elements__description'] }>
					<strong><sup>1</sup> { pisarek.part1 }</strong>{ pisarek.part2 }&nbsp;
					<strong><sup>2</sup> { fog.part1 }</strong>{ fog.part2 }
				</div>
			</div>
		</div>
	);
};
